<section class="request__header" *ngIf="!isDetail">
  <h1 class="request__title">Pedidos</h1>
  <ul class="request__submenu">
    <ng-container *ngIf="hasRequest()">
      <li class="request__submenu-item" routerLinkActive="active" *ngIf="showRequestHistoryTab()">
        <a href="javascript:void(0);" routerLink="history">Histórico</a>
      </li>
      <li class="request__submenu-item" routerLinkActive="active">
        <a href="javascript:void(0);" routerLink="solicitation">Pedidos</a>
      </li>
    </ng-container>

    <li class="request__submenu-item" routerLinkActive="active" *ngIf="hasInformationCPE()">
      <a href="javascript:void(0);" routerLink="request-cpe">Informação CPE</a>
    </li>
  </ul>
</section>

<section class="requests">
  <router-outlet />
</section>
